import React, { useContext } from 'react'
import { LoadingContext } from './loading.context'
import { useTranslation } from "react-i18next"

export function LoadingBar({ laneColor }) {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const color = laneColor ? laneColor : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"

  return (
    <div style={{ width: '100%' }}>
      {/* <LinearProgress style={{ height: '5px' }}
        sx={{
          backgroundColor: 'var(--color-white)',
          '& .MuiLinearProgress-bar': {
            backgroundColor: color
          }
        }}
      /> */}
      <div style={{ display: 'flex', 'flexDirection': 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '80vh' }}>
        <div style={{ width: '400px', height: '200px' }}>
          <img src="/images/vesselGif.gif" style={{ height: '300px', }} alt="vessel" />
        </div>
        <div className="loader-container">
          <div className="loading-text">{t("Loading")}<span className="dots"></span></div>
        </div>
      </div>
    </div>
  )
}